module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAP1BMVEUAAAD/qqrhuYLivILhuoLhu3/jvYHjun/iu4Diu4HivIDiuoHiu4Diu4Hiu4Hiu4Hiu4Hiu4Hhu4Hiu4Hiu4Ez/hnYAAAAFHRSTlMAAzM1OzxJSp2en6Chw8Tk5ufy88AHL9cAAACYSURBVCjPddPtEoQgCAVQrLXsw82U93/WpdlGAZG/Z7iogwC85hlG5XbE3Q3sxJLxdCPz3lay7AFMfc3UaoYy61SY0mpLSovS1pcQk+xlmYS3TA5t3npfa5sbACbMH+vBSKcHvYmFkMdKC/0lq9XjlldjVMY1frWJ3s6UKhPaGVOyw5krNDDS41kw2/46MtINcXPDnVff4QcQeAvjC5Ao7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/zhuangshi.png
// module id = 9GI2
// module chunks = 1